<div class="accordion-item" [class.accordion-item--collapsed]="isCollapsed()">
  <button
    class="accordion-item__header"
    paiRipple
    type="button"
    (click)="toggleState()"
    [attr.aria-expanded]="!isCollapsed()"
    [attr.aria-controls]="contentId"
  >
    <h3 class="accordion-item__title">{{ title() }}</h3>
    <div class="accordion-item__icon">
      <pai-switching-chevron [pointingDown]="isCollapsed()" />
    </div>
  </button>
  <div class="accordion-item__content" [id]="contentId" [attr.aria-hidden]="isCollapsed()">
    <div class="accordion-item__content-inner"><ng-content /></div>
  </div>
</div>
